import { updateObject } from 'utils/helpers/updateObject';
import { actionTypes, LogoutActions, LogoutFailAction, LogoutRequestAction, LogoutSuccessAction, stateStatusType } from './actionType';
import { initialState, LogoutStateProps } from './state';

const logoutRequest = (state: LogoutStateProps, action: LogoutRequestAction) => {
    return updateObject(state, {
        logoutState: {
            ...state.logoutState,
            status: null,
            isLoading: true
        }
    });
};
const logoutSuccess = (state: LogoutStateProps, action: LogoutSuccessAction) => {
    return updateObject(state, {
        logoutState: {
            ...state.logoutState,
            error: null,
            status: stateStatusType.SUCCESS,
            isLoading: false,
            message:action.payload
        }
    });
};

const logoutFail = (state: LogoutStateProps, action: LogoutFailAction) => {
    return updateObject(state, {
        logoutState: {
            ...state.logoutState,
            isLoading: false,
            status: stateStatusType.FAILED,
            error: action.payload
        }
    });
};

const logoutReducer = (state = initialState, action: LogoutActions) => {
    switch (action.type) {
        case actionTypes.LOGOUT_REQUEST:
            return logoutRequest(state, action);
        case actionTypes.LOGOUT_SUCCESS:
            return logoutSuccess(state, action);
        case actionTypes.LOGOUT_FAIL:
            return logoutFail(state, action);
        default:
            return state;
    }
};

export default logoutReducer;